/**
 * IMPORTS
 */
import Store from 'src/store';


/**
 * TYPES
 */
import {ITag} from 'src/aggregates/tags/state.d';
import {ITagById} from 'src/aggregates/tags/state.d';
import {ITagsState} from 'src/aggregates/tags/state.d';


/**
 * CONSTANTS AND DEFINITIONS
 */
const DEFAULT_COLOR = '#00a7cf';

const AVAILABLE_COLORS: string[] = [
    DEFAULT_COLOR,
    '#61bd4f',
    '#f2d600',
    '#ff9f1a',
    '#eb5a46',
    '#c377e0',
    '#0079bf',
    '#00c2e0',
    '#51e898',
    '#ff78cb',
    '#344563',
];


/**
 * CODE
 */

/**
 * I get a tag by id.
 *
 * :param id: tag id
 *
 * :returns: tag or null
 */
function get (id: number): ITag | null
{
    return getState().byId[id] ?? null;
}


/**
 * I get the tags state
 *
 * :returns: tags state
 */
function getState (): ITagsState
{
    return Store.getState().tags;
}


/**
 * I get the tags by id
 *
 * :returns: tags by id
 */
function list (): ITagById
{
    return getState().byId;
}


/**
 * EXPORTS
 */
export {
    AVAILABLE_COLORS,
    DEFAULT_COLOR,
    get,
    getState,
    list,
};
